<template>
  <div class="text-left row">
    <div class="col-12">
      <div class="row">
        <div class="col-lg-2 mb-2 col-sm-12">
              <button
                title="Criar nova agenda"
                class="btn btn-success col"
                @click="openModalAdd()"
              >
               Adicionar Nova Agenda <font-awesome-icon icon="plus" class="pointer" />
              </button>
        </div>
        <div class="col-lg-2 mb-2 col-sm-12">
              <button title="Excluir" class="btn btn-danger col" @click="onDelete()">
               Remover Agendas <font-awesome-icon icon="trash" class="pointer" />
              </button>
        </div>
        <div class="col-lg-6 offset-lg-2 mb-2">
            <b-input-group>
              <input
                type="text"
                class="form-control"
                placeholder="Buscar..."
                v-model="busca"
                @keypress.enter="listAll()"
              />
              <b-input-group-append>
                <b-button variant="btn-sm btn-info" style="z-index: 0" @click="listAll()">
                  <font-awesome-icon icon="search" class="pointer" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
        </div>
      </div>

      <div class="alert mt-4 alert-warning col-12" v-if="lista.length == 0">
        <strong>Atenção!</strong> Nenhuma agenda encontrada
        <!--<font-awesome-icon icon="search" class="pointer" />Buscar-->
      </div>

      <div class="row mt-4">
        <div class="col">
          <table class="table table-dark table-striped table-sm table-responsive-lg text-center">
            <thead class="thead-dark">
              <tr>
                <th scope="col">
                  <b-form-checkbox v-model="selectAllStatus" @change="selectAll()"></b-form-checkbox>
                </th>
                <th scope="col">Nome</th>
                <th scope="col">Opção</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ag in lista" :key="ag._id">
                <td>
                  <b-form-checkbox v-model="ag.selected"></b-form-checkbox>
                </td>
                <td>{{ag.nome}}</td>
                <td>
                  <router-link
                    :to="{ name: 'EditAgenda', params: { id: ag._id } }"
                    class="btn btn-info btn-sm"
                  >Gerenciar contatos</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <my-pagination :total="totalItens" @pageChanged="listAll($event.skip,$event.limit)"></my-pagination>
    </div>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode";
import moment from "moment";
import TitleAddAgenda from "./TitleAddAgenda";

export default {
  data() {
    return {
      lista: [],
      totalItens: 0,
      form: {},
      skip: 0,
      limit: 8,
      busca: "",
      selectAllStatus: false
    };
  },
  methods: {
    selectAll() {
      for (let i = 0; i < this.lista.length; i++) {
        const el = this.lista[i];
        el.selected = !this.selectAllStatus;
      }
    },
    openModalAdd() {
      this.$modal.show(
        TitleAddAgenda,
        {},
        {
          adaptive: true,
          height: "auto",
          scrollable: true
        },
        {
          closed: () => {
            this.listAll();
          }
        }
      );
    },
    async onDelete() {
       if (confirm("Tem certeza que deseja remover todos os selecionados?")) {
      for (let i = 0; i < this.lista.length; i++) {
        const el = this.lista[i];
        if (el.selected) {
          await this.$http.delete(`/v1/v3/agenda/${el._id}`);
        }
      }
      this.listAll();
       }
    },
    async listAll(skip, limit) {
      skip = skip ? skip : this.skip;
      limit = limit ? limit : this.limit;

      let response = await this.$http.get(
        `/v1/v3/agenda/${skip}/${limit}/${this.busca}`
      );
      if (response.data) {
        this.lista = response.data;
        this.totalItens = response.total;
      }
    }
  },
  async mounted() {
    this.listAll();
  }
};
</script>

